// ============================================
// INFRASTRUCTURE - Boletas Repository
// ============================================

import { axiosClient } from './axios-client';
import type { Boleta, FiltrosBoletasDto, BoletaDetalle, ActualizarBoletaDto } from '../../domain/dtos';

export const boletasRepository = {
  /**
   * Obtener boletas con filtros de fecha
   * GET /ventas?desde=YYYY-MM-DD&hasta=YYYY-MM-DD
   */
  async obtenerBoletasConFiltros(filtros: FiltrosBoletasDto): Promise<Boleta[]> {
    const { data } = await axiosClient.get<Boleta[]>('/ventas', {
      params: {
        desde: filtros.desde,
        hasta: filtros.hasta,
      },
    });
    return data;
  },

  /**
   * Obtener detalle de una boleta por ID
   * GET /ventas/{boletaId}
   */
  async obtenerBoletaPorId(boletaId: number): Promise<BoletaDetalle> {
    const { data } = await axiosClient.get<BoletaDetalle>(`/ventas/${boletaId}`);
    return data;
  },

  /**
   * Eliminar boleta por ID
   * DELETE /ventas/{boletaId}
   */
  async eliminarBoleta(boletaId: number): Promise<void> {
    await axiosClient.delete(`/ventas/${boletaId}`);
  },

  /**
   * Actualizar boleta
   * PUT /ventas/{boletaId}
   */
  async actualizarBoleta(boletaId: number, datos: ActualizarBoletaDto): Promise<void> {
    await axiosClient.put(`/ventas/${boletaId}`, datos);
  },
};
